module.exports = __webpack_public_path__ + "fonts/Mulish-ExtraBold.f4c4920f.ttf";